import { FourZeroFour } from "./FourZeroFour.component";

export default FourZeroFour;
